export default __webpack_public_path__ + "static/media/Aflac.f650b380.png";